var map = {
	"./bg.webp": "2964",
	"./cbs.webp": "85d6",
	"./cms.webp": "eb4f",
	"./hotel.webp": "cca3",
	"./ics.webp": "826c",
	"./invoice.webp": "3dec",
	"./onedata.webp": "0b5b",
	"./onedata2.webp": "5659",
	"./ota.webp": "5f10",
	"./pms-activity.webp": "8eda",
	"./pms-manage.webp": "2058",
	"./pms.webp": "e9b5",
	"./qc.webp": "5fe3",
	"./qcs.webp": "43d6",
	"./qcs1.webp": "2147",
	"./rcs.webp": "62a6",
	"./rms.webp": "c4ab",
	"./scrm.webp": "bbba",
	"./title.webp": "f448",
	"./union.webp": "4125",
	"./unit-crm.webp": "d72d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0db8";